import { CloseOutlined } from "@ant-design/icons";
import {
  Card,
  DatePicker,
  Image,
  Tabs,
  Spin,
  Avatar,
  Tooltip as AntTooltip,
  Select,
} from "antd";
import L from "leaflet";
import { Icon } from "leaflet";

import { Component } from "react";

import dayjs from "dayjs";

import VehicleOtherInfoStore from "../store/VehicleOtherInfoStore";
import ShareModalWindow from "./ShareModalWindow";
import withRouter from "../withRouter";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import FuelGraphLivetracking from "./FuelGraphLivetracking";

import wifiIcon from "../assets/images/NewDesign/livetracking/wifi.svg";
import networkIcon from "../assets/images/NewDesign/livetracking/networkIcon.svg";
import infocircle from "../assets/images/NewDesign/livetracking/info-circle.svg";
import infocircleblue from "../assets/images/NewDesign/livetracking/info-circle-blue.svg";
import clockhistory from "../assets/images/NewDesign/livetracking/clock-history.svg";
import clockhistoryblue from "../assets/images/NewDesign/livetracking/clock-history-blue.svg";
import exclamationcircle from "../assets/images/NewDesign/livetracking/exclamation-circle.svg";
import exclamationcircleblue from "../assets/images/NewDesign/livetracking/exclamation-circle-blue.svg";
import Speedometer from "../assets/images/NewDesign/livetracking/Speedometer.svg";
import mapIcon from "../assets/images/NewDesign/livetracking/map.svg";
import clipboardIcon from "../assets/images/NewDesign/livetracking/clipboard-data.svg";
import ssdIcon from "../assets/images/NewDesign/livetracking/device-ssd.svg";

import clipboarddatablue from "../assets/images/NewDesign/livetracking/clipboard-data-blue.svg";
import fuelpumpblue from "../assets/images/NewDesign/livetracking/fuel-pump-blue.svg";
import fuelpump from "../assets/images/NewDesign/livetracking/fuel-pump.svg";

import odometerIcon from "../assets/images/NewDesign/livetracking/odometerIcon.svg";
import powerIcon from "../assets/images/NewDesign/livetracking/power (1).svg";
import latlngIcon from "../assets/images/NewDesign/livetracking/lat-lngIcon.svg";
import locationIcon from "../assets/images/NewDesign/livetracking/geo-alt-fill.svg";

import summarystartloc from "../assets/images/NewDesign/livetracking/summary-start-loc.svg";
import summaryendloc from "../assets/images/NewDesign/livetracking/summary-end-loc.svg";
import workTimeIcon from "../assets/images/NewDesign/livetracking/clock.svg";
import stopTimeIcon from "../assets/images/NewDesign/livetracking/stopwatch.svg";

import alertIcon from "../assets/images/NewDesign/livetracking/exclamation-diamond.svg";

import powerIconGreen from "../assets/images/NewDesign/livetracking/power.svg";
import powerIconRed from "../assets/images/NewDesign/livetracking/powerIconRed.svg";
import powerIconGray from "../assets/images/NewDesign/livetracking/powerIconGray.svg";
import { Tooltip } from "recharts";
import { update } from "lodash";
import FuelGraphStore from "../store/FuelGraphStore";
import personIcon from "../assets/images/NewDesign/livetracking/person-fill.svg";
import config from "../config";

const { RangePicker } = DatePicker;

class VehicleOtherInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      update: 0,
      showFullSummary: false,
      // vehicleSummaryInfo:[],
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
      trackingDataObj: [],
      shareModalVisible: false,
      selectedIndex: null,
      selectedData: [],
      fuelRefillData: [],
      graphData: [],

      activeTab: "1",
      interval: 120,
      driverPerformance: {},
      daySummary: {},
      loading: false,
      showObdData: {}
    };
    this.polyline2 = null;
    this.marker2 = null;

    this.vehicleOtherInfoStore = new VehicleOtherInfoStore();
    this.fuelGraphStore = new FuelGraphStore(this);
    this.calculateDays = this.calculateDays.bind(this);
    this.onRangeChange = this.onRangeChange.bind(this);
    this.removeMarkerPoints = [];

    this.rangePresets = {
      items: [
        {
          label: "Today",
          value: [dayjs(), dayjs().endOf("day")],
          key: 1,
        },
        {
          key: "yesterday",
          label: "Yesterday",
          value: [
            dayjs().subtract(1, "day").startOf("day"),
            dayjs().subtract(1, "day").endOf("day"),
          ],
        },
        {
          key: "Last 7 Days",
          label: "Last 7 Days",
          value: [dayjs().add(-6, "d"), dayjs()],
        },

        {
          label: "Last 30 Days",
          value: [dayjs().add(-29, "d"), dayjs()],
          key: 4,
        },
        {
          label: "This Month",
          value: [dayjs().startOf("month"), dayjs().endOf("month")],
          key: 5,
        },
        {
          label: "Last Month",
          value: [
            dayjs().subtract(1, "month").startOf("month"),
            dayjs().subtract(1, "month").endOf("month"),
          ],
          key: 6,
        },
      ],
    };
  }
  async componentDidMount() {
    // await this.getFuelRefillInfo();
    if (config.pythonReport == 1) {
      await this.getStatusWiseData();
      this.setState({ loadData: 1 });
    }

  }
  componentWillUnmount() {
    // this.clearMap();
    this.clearNewMap();
  }

  getStatusWiseData = async () => {
    await this.vehicleOtherInfoStore.getStatusWiseData({
      vehicleId: this.props.info.vehicleId,
      companyId: this.props.info.companyId,
    });

    await this.setState({ loadData: 1 });
  };
  getFuelRefillInfo = async () => {
    const data = await this.vehicleOtherInfoStore.getFuelRefillData({
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      companyId: this.props.info.companyId,
      vehicleId: [this.props.info.vehicleId],
    });

    await this.setState({
      fuelRefillData: data.fuelrefill,
      graphData: data.graphdata,
      update: 1,
    });
  };
  async getVehicleHistInfo(record) {
    this.vehicleOtherInfoStore.vehiclesHistData = [];
    this.vehicleOtherInfoStore.vehicleSummaryData = [];
    this.vehicleOtherInfoStore.vehicleTripData = [];
    this.vehicleOtherInfoStore.timeWisePolylineArray = [];
    this.setState({ update: 1 });
    await this.vehicleOtherInfoStore.getVehicleHistoryData({
      vehicleId: this.props.info.vehicleId,
      companyId: this.props.info.companyId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });

    if (config.pythonReport === 1) {
      await this.vehicleOtherInfoStore.getVehicleTripData({
        vehicleId: this.props.info.vehicleId,
        companyId: this.props.info.companyId,
        fromDate: this.state.fromDate,
        toDate: this.state.toDate,
      });
    }
    await this.setState({ update: 1 });
  }

  async getVehicleOffilneInfo(resetOffset) {
    await this.vehicleOtherInfoStore.setOfflineData({
      vehicleId: this.props.info.vehicleId,
      companyId: this.props.info.companyId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      resetOffset: resetOffset,
    });

    await this.setState({ update: 1 });
  }

  async getVehicleAlertInfo(record) {
    await this.vehicleOtherInfoStore.getVehicleRuleTriggerData({
      vehicleId: this.props.info.vehicleId,
      companyId: this.props.info.companyId,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
    });

    await this.setState({ update: 1 });
  }

  convertToFormattedTime = (time) => {
    if (time) {
      const [hours, minutes] = time?.split(":");

      const formattedTime = `${hours}: ${minutes}:00`;
      return formattedTime;
    }
  };

  convertToFormattedDate = (dateString) => {
    const dateObject = new Date(dateString);
    const dateStringData = dateObject.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });

    return dateStringData;
  };

  stautsWiseData = () => {
    var lastReportingTime = this.props.info.updatedate;
    var serverCurrentTime = this.props.info.currtime;

    var diff = new Date(serverCurrentTime) - new Date(lastReportingTime);

    diff /= 60000;

    const statusData = this.vehicleOtherInfoStore?.statusData;
    let time;
    if (diff >= 90) {
      time = this.getSectoTime(statusData?.stopSince);
    } else if (this.props.info.acc == 1 && this.props.info.speed == 0) {
      time = this.getSectoTime(statusData?.idleSince);
    } else {
      if (this.props.info.acc == 0 || this.props.info.acc == null) {
        time = this.getSectoTime(statusData?.stopSince);
      } else {
        if (this.props.info.acc == 1 && this.props.info.speed > 0) {
          time = this.getSectoTime(statusData?.runSince);
        }
      }
    }

    return time;
  };
  calculateDays = () => {
    var lastReportingTime = this.props.info.updatedate;
    var serverCurrentTime = this.props.info.currtime;

    var diff = new Date(serverCurrentTime) - new Date(lastReportingTime);

    diff /= 60000;

    let time;
    if (diff >= 90) {
      time = this.getSectoTime(this.props.info?.stopSince);
    } else if (this.props.info.acc == 1 && this.props.info.speed == 0) {
      time = this.getSectoTime(this.props.info?.idleSince);
    } else {
      if (this.props.info.acc == 0 || this.props.info.acc == null) {
        time = this.getSectoTime(this.props.info?.stopSince);
      } else {
        if (this.props.info.acc == 1 && this.props.info.speed > 0) {
          time = this.getSectoTime(this.props.info?.runSince);
        }
      }
    }
    return time;
  };

  getSectoTime = (c) => {
    var g, f, b, e;
    e = c;
    b = Math.floor(e / 60);
    e = e % 60;
    f = Math.floor(b / 60);
    b = b % 60;
    g = Math.floor(f / 24);
    f = f % 24;
    var a = (g < 10 ? "0" + g : g) + " days,";
    a += f < 10 ? "0" + f : f;
    a += ":" + (b < 10 ? "0" + b : b);
    a += ":" + (e < 10 ? "0" + e : e);
    return a;
  };
  // getColor = (status) => {
  //   let statusColor;
  //   switch (status) {
  //     case "No Data":
  //       statusColor = "text-secondary";
  //       break;
  //     case "Running":
  //       statusColor = "text-success";
  //       break;
  //     case "Stopped":
  //       statusColor = "text-danger";
  //       break;
  //     case "Idle":
  //       statusColor = "text-warning";
  //       break;
  //   }
  //   return "bi bi-circle-fill " + statusColor;
  // };
  converteToDaysFormat = (val) => {
    const stopDurationSeconds = val || 0;
    const days = Math.floor(stopDurationSeconds / (24 * 60 * 60));
    const hours = Math.floor(
      (stopDurationSeconds % (24 * 60 * 60)) / (60 * 60)
    );
    const minutes = Math.floor((stopDurationSeconds % (60 * 60)) / 60);
    const seconds = stopDurationSeconds % 60;

    const formattedStopDuration = `${days
      .toString()
      .padStart(2, "0")} days, ${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
    return formattedStopDuration;
  };

  // getColor = (status) => {
  //   let statusClass = "status-icon ";

  //   switch (status) {
  //     case "No Data":
  //       statusClass += "status-no-data";
  //       break;
  //     case "Running":
  //       statusClass += "status-running";
  //       break;
  //     case "Stopped":
  //       statusClass += "status-stopped";
  //       break;
  //     case "Idle":
  //       statusClass += "status-idle";
  //       break;
  //   }

  //   return "bi bi-circle-fill " + statusClass;
  // };

  getStatusColorClass = (status) => {
    switch (status) {
      case "No Data":
        return "status-no-data";
      case "Running":
        return "status-running";
      case "Stopped":
        return "status-stopped";
      case "Idle":
        return "status-idle";
      default:
        return "status-no-data";
    }
  };
  onRangeChange = async (dates, dateStrings) => {
    const startDate = new Date(dates[1]);
    const endDate = new Date(dates[0]);
    const diffrence = Math.round((startDate - endDate) / (1000 * 60 * 60 * 24));

    if (diffrence === 0 || diffrence === 1) {
      this.setState({ showFullSummary: false });
    } else {
      this.setState({ showFullSummary: true });
    }

    if (dates) {
      await this.setState({
        fromDate: dayjs(dateStrings[0]).format("YYYY-MM-DD 00:00:00"),
        toDate: dayjs(dateStrings[1]).format("YYYY-MM-DD 23:59:59"),
      });

      await this.getFuelRefillInfo();

      this.setState({}, async () => {
        console.log("Updated fuelRefillData:", this.state.fuelRefillData);
        await this.showFuelIcons();
      });

      const removeData = this.state.fuelRefillData.map((val) => {
        if (val.latitude && val.longitude) {
          return [Number(val.latitude), Number(val.longitude)];
        }
      });

      if (this.props.mapRef.current && removeData.length > 0) {
        this.props.mapRef.current.eachLayer((layer) => {
          if (layer instanceof L.Marker) {
            const markerLatLng = layer.getLatLng();

            const removeFuelmarker = removeData.some((point) =>
              markerLatLng.equals(L.latLng(point))
            );
            if (removeFuelmarker) {
              this.props.mapRef.current.removeLayer(layer);
            }
          }
        });
      }

      await this.getVehicleHistInfo();
      // await this.clearMap();
      await this.clearNewMap();

      await this.getVehicleOffilneInfo(0);
      await this.showPolyline();
      await this.setState({ update: 1 });
    }
  };

  clearMap = async () => {
    let mapRef = this.props.This.mapRef;
    if (this.props.mapRef.current && this.removeMarkerPoints.length > 0) {
      this.props.mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          const markerLatLng = layer.getLatLng();
          // Check if the marker's coordinates are in the removeMarkerPoints array
          const isMarkerInRemovePoints = this.removeMarkerPoints.some((point) =>
            markerLatLng.equals(L.latLng(point))
          );
          if (isMarkerInRemovePoints) {
            // If the marker's coordinates are in the removeMarkerPoints array, remove it from the map
            this.props.mapRef.current.removeLayer(layer);
          }
        }
      });
    }
    if (this.props.mapRef) {
      await this.props.mapRef?.current?.eachLayer((layer) => {
        if (layer instanceof L.Polyline) {
          this.props.mapRef.current.removeLayer(layer);
        }
      });
    }
    this.vehicleOtherInfoStore.offlineData = [];
    this.vehicleOtherInfoStore.offlineDataNewObj = [];
    this.vehicleOtherInfoStore.idleAndStopPointsArray = [];
    this.vehicleOtherInfoStore.totalCount = null;
    this.vehicleOtherInfoStore.total = 0;
    this.vehicleOtherInfoStore.pgcount = 1;
    this.vehicleOtherInfoStore.offset = 0;

    // await this.clearFuelIcons();
  };

  clearNewMap = () => {
    this.props.onShowPolyline?.(null);
    this.props.onShowTrackingPolyline?.(null);
    this.props.fuelMarkersData?.(null);
    // this.props.idleStopMarkersData?.(null);

    this.vehicleOtherInfoStore.offlineData = [];
    this.vehicleOtherInfoStore.offlineDataNewObj = [];
    this.vehicleOtherInfoStore.idleAndStopPointsArray = [];
    this.vehicleOtherInfoStore.totalCount = null;
    this.vehicleOtherInfoStore.total = 0;
    this.vehicleOtherInfoStore.pgcount = 1;
    this.vehicleOtherInfoStore.offset = 0;
  };

  clearFuelIcons = () => {
    const data = this.state.fuelRefillData.map((val) => {
      if (val.latitude && val.longitude) {
        return [Number(val.latitude), Number(val.longitude)];
      }
    });

    if (this.props.mapRef.current && data.length > 0) {
      this.props.mapRef.current.eachLayer((layer) => {
        if (layer instanceof L.Marker) {
          const markerLatLng = layer.getLatLng();

          const removeFuelmarker = data.some((point) =>
            markerLatLng.equals(L.latLng(point))
          );
          if (removeFuelmarker) {
            this.props.mapRef.current.removeLayer(layer);
          }
        }
      });
    }
  };

  // showPolyline = async () => {
  //   console.log(
  //     this.props.This.mapRef.current,
  //     "this.props.This.mapRef.current"
  //   );
  //   const polyline = await L.polyline(
  //     this.vehicleOtherInfoStore.offlineDataNewObj.length > 0
  //       ? [...this.vehicleOtherInfoStore.offlineDataNewObj]
  //       : [],
  //     {
  //       color: "grey",
  //       smoothFactor: 5,
  //       weight: 4,
  //     },
  //     15
  //   ).addTo(this.props.This.mapRef.current);
  //   const bounds = polyline.getBounds();

  //   if (bounds.isValid()) {
  //     await this.props.This.mapRef.current.fitBounds(bounds, {
  //       maxZoom: 20,
  //     });
  //   }
  //   polyline.arrowheads({
  //     size: "6px",
  //     color: "blue", // Set arrow color to blue
  //   });
  // };

  showPolyline = () => {
    const data = this.vehicleOtherInfoStore.offlineDataNewObj;

    if (!data || data.length === 0) return;

    const geoJson = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: data.map((p) => [Number(p[1]), Number(p[0])]),
      },
    };

    // Send polyline to LiveTracking
    this.props.onShowPolyline(geoJson);
  };

  //   drawIdleAndStopIcon = (vehicleObj, activity) => {
  //     const activityImage = require(`../assets/images/BaloonIcons/${activity}-north.png`);
  //     const marker = L.marker([vehicleObj.latitude, vehicleObj.longitude], {
  //       icon: L.divIcon({
  //         className: "custom-marker",
  //         iconSize: [25, 25],
  //         html: `
  //           <img src=${activityImage} alt="Icon" style=  "width: 100%; height: 100%;">`,
  //       }),
  //     })
  //       .bindTooltip(
  //         `<div style='background:#00ff00;border:solid 1px #000;text-align:left;padding:10px;'>
  //   <b>${this.context.translate("_VEHICLE_NO_")}:</b> ${
  //           vehicleObj.vehicleNo
  //         } <br/>
  //   <b>${this.context.translate("_IDLE_FROM_")}:</b> ${vehicleObj.fromdate} <br/>
  //   <b>${this.context.translate("_IDLE_TO_")}:</b> ${vehicleObj.todate} <br/>
  //   <b>${this.context.translate(
  //     "_FLEET_REPORTS_STARTSTOPREPORT_ELAPSEDTIME_"
  //   )}:</b> ${vehicleObj.elapsedTime} <br/>

  // </div>`,
  //         {
  //           maxWidth: 300,
  //           direction: "top",
  //           // className: "my-labels"
  //         }
  //       )

  //       .addTo(this.props.This.mapRef.current);
  //   };

  drawIdleAndStopIcon = () => {
    const data = this.vehicleOtherInfoStore.idleAndStopPointsArray;

    if (!data || data.length === 0) return;

    const idleStopPoints = {
      type: "FeatureCollection",
      features: data.map((item) => {
        const { vehicleObj, activity } = item;

        return {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [
              Number(vehicleObj.longitude),
              Number(vehicleObj.latitude),
            ],
          },
          properties: {
            icon: `${activity}-north`,
            activity,
            vehicleNo: vehicleObj.vehicleNo,
            fromdate: vehicleObj.fromdate,
            todate: vehicleObj.todate,
            elapsedTime: vehicleObj.elapsedTime,
          },
        };
      }),
    };

    this.props.idleStopMarkersData?.(idleStopPoints);
  };

  showTrackingPolyline = async () => {
    this.props.onClearTrackingPolyline();

    let dta = this.vehicleOtherInfoStore.idleAndStopPointsArray?.map(
      (val) => val.vehicleObj
    );
    this.removeMarkerPoints = dta.map((val) => [
      Number(val.latitude),
      Number(val.longitude),
    ]);

    this.vehicleOtherInfoStore.idleAndStopPointsArray.map(async (val) => {
      await this.drawIdleAndStopIcon(val.vehicleObj, val.activity);
    });

    const data = this.vehicleOtherInfoStore.timeWisePolylineArray;

    const geoJson = {
      type: "Feature",
      geometry: {
        type: "LineString",
        coordinates: data.map((p) => [Number(p[1]), Number(p[0])]),
      },
    };

    this.props.onShowTrackingPolyline(geoJson);
  };

  // showTrackingPolyline = async () => {
  //   if (this.polyline2) {
  //     this.props.This.mapRef.current.removeLayer(this.polyline2);
  //   }

  //   let dta = this.vehicleOtherInfoStore.idleAndStopPointsArray?.map(
  //     (val) => val.vehicleObj
  //   );
  //   this.removeMarkerPoints = dta.map((val) => [
  //     Number(val.latitude),
  //     Number(val.longitude),
  //   ]);

  //   const showMarkers = this.vehicleOtherInfoStore.idleAndStopPointsArray.map(
  //     async (val) => {
  //       await this.drawIdleAndStopIcon(val.vehicleObj, val.activity);
  //     }
  //   );
  //   this.polyline2 = await L.polyline(
  //     this.vehicleOtherInfoStore.timeWisePolylineArray.length > 0
  //       ? [...this.vehicleOtherInfoStore.timeWisePolylineArray]
  //       : [],
  //     {
  //       color: "#37d5ed",
  //       smoothFactor: 5,
  //       weight: 6,
  //     },
  //     15
  //   ).addTo(this.props.This.mapRef.current);
  //   const bounds2 = this.polyline2.getBounds();

  //   await this.props.This.mapRef.current.fitBounds(bounds2, {
  //     maxZoom: 20,
  //   });
  // };

  getGPSStatus(status) {
    if (status === 1) {
      return <>Running</>;
    }
    if (status === 0) {
      return <>Stop</>;
    }
    if (status === undefined || status === null) {
      return <>No Data</>;
    }
  }

  copyTextToClipboard = () => {
    const textToCopy = this.props.info.formatted_address;

    // Create a temporary input element to copy the text
    const tempInput = document.createElement("input");
    document.body.appendChild(tempInput);
    tempInput.value = textToCopy;
    tempInput.select();

    document.execCommand("copy");

    document.body.removeChild(tempInput);
  };

  showFuelIcons = () => {
    const fuelData = {
      type: "FeatureCollection",
      features: this.state.fuelRefillData?.map((val) => ({
        type: "Feature",
        geometry: {
          type: "Point",
          coordinates: [Number(val.longitude), Number(val.latitude)],
        },
        properties: {
          icon: "map-car-icon-green",
          vehicleNo: val.vehicleNo,
          location: val.location,
          refillfuel: val.refillfuel,
          refillfuellevel: val.refillfuellevel,
        },
      })),
    };

    this.props.fuelMarkersData?.(fuelData);
  };
  // showFuelIcons = () => {
  //   this.state.fuelRefillData.forEach((value, index) => {
  //     if (value.latitude && value.longitude) {
  //       var locationIcon = new Icon({
  //         iconUrl: require("../assets/images/map-car-icon-green.png"),
  //         iconSize: [30, 35], // size of the icon
  //       });

  //       L.marker([value?.latitude, value?.longitude])
  //         .setIcon(locationIcon)
  //         .addTo(this.props.This.mapRef.current)
  //         .bindTooltip(
  //           `<div style='background:#00ff00;border:solid 1px #000;text-align:left;padding:10px;'>
  //       <b>${this.context.translate("_VEHICLE_NO_")} :</b> ${
  //             value.vehicleNo ? value.vehicleNo : "-"
  //           } <br/>
  //       <b>${this.context.translate("_LOCATION_")} :</b> ${
  //             value.location
  //               ? value.location.replace(/(.{30})/g, "$1<br/>")
  //               : "-"
  //           } <br/>
  //        <b>${this.context.translate("_REFILL_FUEL_")} :</b> ${
  //             value.refillfuel ? value.refillfuel : "-"
  //           } L<br/>_BEFORE_LEVEL_
  //       <b>${this.context.translate("_BEFORE_LEVEL_")} :</b> ${
  //             value.beforLevel ? value.beforLevel : "-"
  //           } L<br/>
  //        <b>${this.context.translate("_REFILL_FUEL_LEVEL_")} :</b> ${
  //             value.refillfuellevel ? value.refillfuellevel : "-"
  //           } L
  //     </div>`,
  //           { direction: "right" }
  //         );
  //       this.props.This.mapRef.current.setView(
  //         [Number(value?.latitude), Number(value?.longitude)],
  //         16
  //       );
  //     }
  //   });

  //   this.setState({ update: 1 });
  // };

  handleTabChange = (key) => {
    this.setState({
      activeTab: key,
    });
  };

  formatTime = (totalSeconds) => {
    const days = Math.floor(totalSeconds / (24 * 3600));
    const hours = Math.floor((totalSeconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${String(days).padStart(2, "0")} days, ${String(hours).padStart(
      2,
      "0"
    )}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  };

  // convertMinutesToFormattedTime(minutes) {
  //   // console.log(minutes);
  //   const days = Math.floor(minutes / (24 * 60));
  //   const remainingMinutes = minutes % (24 * 60);
  //   const hours = Math.floor(remainingMinutes / 60);
  //   const minutesPart = remainingMinutes % 60;

  //   const daysString = days < 10 ? `0${days}` : days.toString();
  //   const hoursString = hours < 10 ? `0${hours}` : hours.toString();
  //   const minutesString =
  //     minutesPart < 10 ? `0${minutesPart}` : minutesPart.toString();

  //   return `${daysString} days, ${hoursString}:${minutesString}:00`;
  // }

  getDateDiff(currtime, updatedate) {
    // console.log(currtime,updatedate)
    var startDate = dayjs(currtime);
    var endDate = dayjs(updatedate);
    // console.log("In");
    // Calculate the time difference in milliseconds
    var timeDifference = startDate - endDate;

    // Calculate days, hours, minutes, and seconds
    var days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    var hours = Math.floor(
      (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    var a = (days < 10 ? "0" + days : days) + " days,";
    a += hours < 10 ? "0" + hours : hours;
    a += ":" + (minutes < 10 ? "0" + minutes : minutes);
    a += ":" + (seconds < 10 ? "0" + seconds : seconds);
    return a;
  }

  getStatusWiseCarImage() {
    switch (this.props.info?.currentStatus) {
      case "Running":
        return require("../assets/images/NewDesign/livetracking/car-trans1green.png");
      case "Stopped":
        return require("../assets/images/NewDesign/livetracking/car-trans1red.png");
      case "Idle":
        return require("../assets/images/NewDesign/livetracking/car-trans1-1.png");
      case "NoData":
        return require("../assets/images/NewDesign/livetracking/car-trans1grey.png");
      default:
        return require("../assets/images/NewDesign/livetracking/car-trans1grey.png"); // fallback
    }
  }

  bleTempValues = (info) => {
    const value = info?.BLETemp;

    if (!value || value === "") {
      return "NA";
    }

    // Split by comma (with or without space)
    const arr = value.split(",").map((v) => v.trim());
    const formatted = [];

    for (let i = 0; i < arr.length; i++) {
      if (!arr[i] || arr[i] === "NA") continue;

      // NEW FORMAT → sensorId:value
      if (arr[i].includes(":")) {
        const [sensorId, sensorValue] = arr[i].split(":");

        formatted.push(
          <div key={i}>
            <b>{`Sensor ${sensorId} : `}</b>
            {sensorValue}
          </div>
        );
      }
      // OLD FORMAT → just value
      else {
        formatted.push(
          <div key={i}>
            <b>{`Sensor ${i + 1} : `}</b>
            {arr[i]}
          </div>
        );
      }
    }

    return formatted.length ? formatted : "NA";
  };
  bleHumidityValues = (info) => {
    const value = info?.BLEHumidity;
    if (!value || value === "") {
      return "NA";
    }

    // Split by comma (with or without space)
    const arr = value.split(",").map((v) => v.trim());
    const formatted = [];

    for (let i = 0; i < arr.length; i++) {
      if (!arr[i] || arr[i] === "NA") continue;

      // NEW FORMAT → sensorId:value
      if (arr[i].includes(":")) {
        const [sensorId, sensorValue] = arr[i].split(":");

        formatted.push(
          <div key={i}>
            <b>{`Sensor ${sensorId} : `}</b>
            {sensorValue}
          </div>
        );
      }
      // OLD FORMAT → just value
      else {
        formatted.push(
          <div key={i}>
            <b>{`Sensor ${i + 1} : `}</b>
            {arr[i]}
          </div>
        );
      }
    }

    return formatted.length ? formatted : "NA";
  };

  totalWeight = (info) => {
    // console.log(info, "info");
    var loadVoltage = info.loadVoltage;
    var weightFactor = info.weightFactor;

    // console.log(loadVoltage, "loadVoltage", weightFactor, "weightFactor");
    if (loadVoltage != null && weightFactor != null) {
      var loadKg = loadVoltage * weightFactor;

      // console.log(loadKg, "loadKg", info.emptyWeight);
      if (loadKg > info.emptyWeight) {
        return Math.round(loadKg);
      } else {
        return Math.round(info.emptyWeight);
      }
    } else {
      return "NA";
    }
  };

  activityTab = () => {
    return (
      <Spin spinning={this.vehicleOtherInfoStore.loading}>
        <div className="activity-tab">
          <div className="activity-running">
            <div className="activity-running-div">
              <span className="title">
                {this.context.translate("_RUNNING_")}
              </span>
              <Image
                src={require("../assets/images/NewDesign/livetracking/image 26.png")}
                // src={activeCarIcon}
                style={{ height: "24px", width: "24px" }}
              />
            </div>

            <span className="date">
              {this.state.daySummary?.travelduration} Hrs
            </span>
          </div>

          <div className="activity-idle">
            <div className="activity-idle-div">
              <span className="title">{this.context.translate("_IDLE_")} </span>
              <Image
                src={require("../assets/images/NewDesign/livetracking/image 25.png")}
                // src={idleCarIcon}
                style={{ height: "24px", width: "24px" }}
              />
            </div>

            <span className="date">
              {this.state.daySummary?.idleduration} Hrs
            </span>
          </div>

          <div className="activity-stop">
            <div className="activity-stop-div">
              <span className="title">{this.context.translate("_STOP_")} </span>
              <Image
                src={require("../assets/images/NewDesign/livetracking/image 24.png")}
                // src={stopCarIcon}
                style={{ height: "24px", width: "24px" }}
              />
            </div>

            <span className="date">
              {this.state.daySummary?.stopduration} Hrs
            </span>
          </div>

          <div className="activity-inactive">
            <div className="activity-inactive-div">
              <span className="title">
                {" "}
                {this.context.translate(
                  "_FLEET_USER_USERLIST_STATUS_INACTIVE_"
                )}
              </span>
              <Image
                src={require("../assets/images/NewDesign/livetracking/image 23.png")}
                // src={expiredIcon}
                style={{ height: "24px", width: "24px" }}
              />
            </div>

            <span className="date">
              {" "}
              {this.state.daySummary?.exidleduration} Hrs
            </span>
          </div>

          <div className="driver-performance">
            <div className="driver-performance-title-div">
              <span className="title">
                {this.context.translate("_DRIVER_PERFORMANCE_")}
              </span>

              <span>
                <Image
                  src={personIcon}
                  style={{ height: "15px", width: "15px" }}
                />
              </span>
            </div>

            <div className="driver-performance-list">
              <li className="listItems">
                <span>{this.context.translate("_HARSH_BRACKING_")}</span>
                <small>
                  {config.project === "proawtltrack"
                    ? this.state.driverPerformance?.harshBreak ?? 0
                    : this.state.driverPerformance?.harshbreak ?? 0}
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_OVER_SPEED_")}</span>
                <small>
                  {" "}
                  {config.project === "proawtltrack"
                    ? this.state.driverPerformance?.overSpeed ?? 0
                    : this.state.driverPerformance?.overspeedCount ?? 0}
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_EXIDLE_")}</span>
                <small> {this.state.driverPerformance?.exIdleCount ?? 0}</small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_HARSH_ACCELERATION_")}</span>
                <small>
                  {" "}
                  {config.project === "proawtltrack"
                    ? this.state.driverPerformance?.Harshaccelcounter ?? 0
                    : this.state.driverPerformance?.harshAcc ?? 0}
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_ACCIDENT_COUNT_")}</span>
                <small>0</small>
              </li>
            </div>
          </div>
        </div>
      </Spin>
    );
  };

  activityTabAWTL = () => {
    return (
      <Spin spinning={this.vehicleOtherInfoStore.loading}>
        <div className="activity-tab">
          <div className="driver-performance">
            <div className="driver-performance-title-div">
              <span className="title">
                {this.context.translate("_TODAY_ACTIVITY_")}
              </span>

              <span>
                <Image
                  src={require("../assets/images/NewDesign/livetracking/image 26.png")}
                  style={{ height: "20x", width: "18px" }}
                />
              </span>
            </div>

            <div className="driver-performance-list">
              <li className="listItems">
                <span>{this.context.translate("_TOTAL_KM_")}</span>
                <small>
                  {this.state.daySummary?.distanceTravelled || "0"} Km
                </small>
              </li>

              <li className="listItems">
                <span> {this.context.translate("_TOTAL_RUNNING_HRS_")}</span>
                <small>
                  {" "}
                  {this.state.daySummary?.travelduration || "00:00:00"} Hrs
                </small>
              </li>

              <li className="listItems">
                <span> {this.context.translate("_RUNNING_")}</span>
                <small>
                  {" "}
                  {this.state.daySummary?.movingduration || "00:00:00"} Hrs
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_IDLE_")}</span>
                <small>
                  {" "}
                  {this.state.daySummary?.idleduration || "00:00:00"} Hrs
                </small>
              </li>

              <li className="listItems">
                <span> {this.context.translate("_EXIDLE_")}</span>
                <small>
                  {" "}
                  {this.state.daySummary?.exidleduration || "00:00:00"} Hrs
                </small>
              </li>

              <li className="listItems">
                <span> {this.context.translate("_STOP_")}</span>
                <small>
                  {" "}
                  {this.state.daySummary?.stopduration || "00:00:00"} Hrs
                </small>
              </li>
            </div>
          </div>
          <div className="driver-performance">
            <div className="driver-performance-title-div">
              <span className="title">
                {this.context.translate("_DRIVER_PERFORMANCE_")}
              </span>

              <span>
                <Image
                  src={personIcon}
                  style={{ height: "15px", width: "15px" }}
                />
              </span>
            </div>

            <div className="driver-performance-list">
              <li className="listItems">
                <span>{this.context.translate("_HARSH_BRACKING_")}</span>
                <small>
                  {config.project === "proawtltrack"
                    ? this.state.driverPerformance?.harshBreak ?? 0
                    : this.state.driverPerformance?.harshbreak ?? 0}
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_OVER_SPEED_")}</span>
                <small>
                  {" "}
                  {config.project === "proawtltrack"
                    ? this.state.driverPerformance?.overSpeed ?? 0
                    : this.state.driverPerformance?.overspeedCount ?? 0}
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_EXIDLE_")}</span>
                <small> {this.state.driverPerformance?.exIdleCount ?? 0}</small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_HARSH_ACCELERATION_")}</span>
                <small>
                  {" "}
                  {config.project === "proawtltrack"
                    ? this.state.driverPerformance?.Harshaccelcounter ?? 0
                    : this.state.driverPerformance?.harshAcc ?? 0}
                </small>
              </li>

              <li className="listItems">
                <span>{this.context.translate("_ACCIDENT_COUNT_")}</span>
                <small>0</small>
              </li>
            </div>
          </div>
        </div>
      </Spin>
    );
  };

  convertDifferenceFromMidnight = (dateTimeStr) => {
    if (!dateTimeStr) return "";

    const givenDate = new Date(dateTimeStr);

    const midnight = new Date(dateTimeStr);
    midnight.setHours(0, 0, 0, 0);

    const diffMs = givenDate - midnight;
    const totalMinutes = Math.floor(diffMs / 60000);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours}h ${minutes}min`;
  };

  showProAwtlSummary = () => {
    const groupedByDate = {};

    this.vehicleOtherInfoStore.vehicleSummaryData?.forEach((item) => {
      const date = item.startTime?.split(" ")[0];
      if (!groupedByDate[date])
        groupedByDate[date] = { summary: item, trips: [] };
    });

    // Attach trips from vehicleTripData
    Object.entries(this.vehicleOtherInfoStore.vehicleTripData || {}).forEach(
      ([date, trips]) => {
        if (groupedByDate[date]) groupedByDate[date].trips = trips;
      }
    );
    return (
      <>
        {" "}
        <Spin spinning={this.vehicleOtherInfoStore.loading}>
          {this.state.showFullSummary && (
            <div className="fullSummaryDiv">
              <div className="summary-div">
                <span className="summary-text">
                  {this.context.translate("_FULL_SUMMARY_")}
                </span>
              </div>

              <div className="summary-start-location">
                <div className="summary-start-location-div">
                  <div className="title">
                    {" "}
                    {this.context.translate("_START_LOCATION_")}
                  </div>
                  <Image src={summarystartloc} />
                </div>

                <span className="value">
                  {
                    this.vehicleOtherInfoStore?.vehicleFullSummary
                      ?.startLocation
                  }
                </span>
              </div>

              <div className="summary-end-location">
                <div className="summary-end-location-div">
                  <div className="title">
                    {this.context.translate("_FINISH_LOCATION_")}
                  </div>
                  <Image src={summaryendloc} />
                </div>

                <span className="value">
                  {this.vehicleOtherInfoStore?.vehicleFullSummary?.endLocation}
                </span>
              </div>

              <div className="summary-work-time">
                <div className="summary-work-time-div">
                  <div className="title">
                    {this.context.translate("_WORK_TIME_")}
                  </div>
                  <Image src={workTimeIcon} />
                </div>

                <span className="value">
                  {" "}
                  {
                    this.vehicleOtherInfoStore?.vehicleFullSummary
                      ?.travelduration
                  }
                </span>
              </div>

              <div className="summary-work-time">
                <div className="summary-work-time-div">
                  <div className="title">
                    {this.context.translate("_FLEET_STOP_TIME_")}
                  </div>
                  <Image src={stopTimeIcon} />
                </div>

                <span className="value">
                  {this.vehicleOtherInfoStore?.vehicleFullSummary?.stopduration}
                </span>
              </div>

              <div className="summary-mileage">
                <div className="summary-mileage-div">
                  <div className="title">
                    {this.context.translate("_MILEAGE_")}
                  </div>
                  <Image src={mapIcon} />
                </div>

                <span className="value">
                  {this.vehicleOtherInfoStore?.vehicleFullSummary?.distanceTravel?.toFixed(
                    2
                  )}
                </span>
              </div>
            </div>
          )}
          <>
            {" "}
            {Object.entries(groupedByDate).map(([date, data], i) => {
              const summary = data.summary;
              const trips = data.trips;

              return (
                <div key={i} className="summary-main">
                  <div
                    className="summary-click"
                    onClick={async () => {
                      // await this.clearMap();
                      this.vehicleOtherInfoStore.histTrackingClickPolylineObj =
                        [];
                      this.vehicleOtherInfoStore.timeWisePolylineArray = [];
                      this.vehicleOtherInfoStore.idleAndStopPointsArray = [];
                      if (this.polyline2) {
                        this.props.This.mapRef.current.removeLayer(
                          this.polyline2
                        );
                      }
                      await this.vehicleOtherInfoStore.getHistoryTrackingData({
                        vehicleId: this.props.info.vehicleId,
                        companyId: this.props.info.companyId,
                        fromDate: summary.startTime,
                        toDate: summary.stopTime,
                      });

                      await this.showPolyline();
                      await this.setState({ update: 1 });
                    }}
                  >
                    <div className="summary-div">
                      <span className="summary-text">
                        {this.context.translate("_SUMMARY_")}
                      </span>
                    </div>

                    <div className="summary-start-location">
                      <div className="summary-start-location-div">
                        <div className="title">
                          {this.context.translate("_START_LOCATION_")}
                        </div>
                        <Image src={summarystartloc} />
                      </div>
                      <span className="value">{summary.startLocation}</span>
                    </div>

                    <div className="summary-end-location">
                      <div className="summary-end-location-div">
                        <div className="title">
                          {this.context.translate("_FINISH_LOCATION_")}
                        </div>
                        <Image src={summaryendloc} />
                      </div>
                      <span className="value">{summary.stopLocation}</span>
                    </div>

                    <div className="summary-work-time">
                      <div className="summary-work-time-div">
                        <div className="title">
                          {this.context.translate("_WORK_TIME_")}
                        </div>
                        <Image src={workTimeIcon} />
                      </div>
                      <span className="value">
                        {summary.travelduration >= 3
                          ? summary.travelduration.toFixed(2)
                          : summary.travelduration}
                      </span>
                    </div>

                    <div className="summary-work-time">
                      <div className="summary-work-time-div">
                        <div className="title">
                          {this.context.translate("_FLEET_STOP_TIME_")}
                        </div>
                        <Image src={stopTimeIcon} />
                      </div>

                      <span className="value">{summary?.stopduration}</span>
                    </div>
                    <div className="summary-mileage">
                      <div className="summary-mileage-div">
                        <div className="title">
                          {this.context.translate("_MILEAGE_")}
                        </div>
                        <Image src={mapIcon} />
                      </div>
                      <span className="value">
                        {summary.distanceTravel?.toFixed(2)}
                      </span>
                    </div>

                    <div className="summary-date">
                      <span className="summary-text">{date}</span>
                    </div>
                  </div>
                  {trips?.map((trip, ind) => (
                    <div className="summary-trip-block" key={ind}>
                      <div className="summary-trip-duration-block">
                        {ind === 0 ? (
                          <div
                            onClick={async () => {
                              // await this.clearMap();
                              this.vehicleOtherInfoStore.timeWisePolylineArray =
                                [];
                              const resp =
                                await this.vehicleOtherInfoStore.getHistoryTrackingData2(
                                  {
                                    vehicleId: this.props.info.vehicleId,
                                    companyId: this.props.info.companyId,
                                    fromDate: trip.startTime,
                                    toDate: trip.stopTime,
                                  }
                                );

                              resp > 0 && (await this.showTrackingPolyline());
                              // await this.showTrackingPolyline();
                              await this.setState({
                                update: 1,
                              });
                            }}
                          >
                            <div className="duration-row">
                              <div className="d-flex gap-2">
                                <p
                                  className="statusStop"
                                  style={{ width: "40px" }}
                                >
                                  00:00
                                </p>
                                <p className="duration-text">
                                  {this.context.translate("_STOP_DURATION_")}
                                </p>
                              </div>
                              <p>
                                {this.convertDifferenceFromMidnight(
                                  trip.stopTime
                                )}
                              </p>
                            </div>

                            <div className="duration-row">
                              <div className="d-flex gap-2">
                                <p
                                  className="statusStart"
                                  style={{ width: "40px" }}
                                >
                                  {trip.startTime.split(" ")[1].slice(0, 5)}{" "}
                                  <br />
                                  {this.context.translate("_START_")}
                                </p>
                                <p className="duration-text">
                                  {this.context.translate("_DRIVING_DURATION_")}{" "}
                                  <br />
                                  {this.context.translate("_MILEAGE_")}
                                </p>
                              </div>
                              <p>
                                {this.convertToFormattedTime(trip.startTill)}{" "}
                                <br />
                                {trip.distanceTravelled} Km
                              </p>
                            </div>

                            <div className="duration-row">
                              <div className="d-flex gap-2">
                                <p
                                  className="statusStop"
                                  style={{ width: "40px" }}
                                >
                                  {trip.stopTime?.split(" ")[1]?.slice(0, 5) ||
                                    "00:00"}
                                </p>
                                <p className="duration-text">
                                  {this.context.translate("_STOP_DURATION_")}
                                </p>
                              </div>
                              <p>
                                {this.convertToFormattedTime(trip.stopTill)}
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div
                            onClick={async () => {
                              this.vehicleOtherInfoStore.timeWisePolylineArray =
                                [];
                              await this.props.This.setState({
                                update: 1,
                              });
                              // await this.showTrackingPolyline();
                              const resp =
                                await this.vehicleOtherInfoStore.getHistoryTrackingData2(
                                  {
                                    vehicleId: this.props.info.vehicleId,
                                    companyId: this.props.info.companyId,
                                    fromDate: trip.startTime,
                                    toDate: trip.stopTime,
                                  }
                                );

                              resp > 0
                                ? await this.showTrackingPolyline()
                                : (this.vehicleOtherInfoStore.timeWisePolylineArray =
                                  []);
                            }}
                          >
                            <div className="duration-row">
                              <div className="d-flex gap-2">
                                <p
                                  className="statusStart"
                                  style={{ width: "40px" }}
                                >
                                  {trip.startTime?.split(" ")[1].slice(0, 5)}{" "}
                                  <br />
                                  {this.context.translate("_START_")}
                                </p>
                                <p className="duration-text">
                                  {this.context.translate("_DRIVING_DURATION_")}{" "}
                                  <br />
                                  {this.context.translate("_MILEAGE_")}
                                </p>
                              </div>
                              <p>
                                {this.convertToFormattedTime(trip.startTill)}{" "}
                                <br />
                                {trip.distanceTravelled} Km
                              </p>
                            </div>

                            <div className="duration-row">
                              <div className="d-flex gap-2">
                                <p
                                  className="statusStop"
                                  style={{ width: "40px" }}
                                >
                                  {trip.stopTime?.split(" ")[1]?.slice(0, 5)}{" "}
                                  <br />
                                  {this.context.translate("_STOP_")}
                                </p>
                                <p className="duration-text">
                                  {this.context.translate("_STOP_DURATION_")}
                                </p>
                              </div>
                              <p>
                                {this.convertToFormattedTime(trip.stopTill)}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </>
        </Spin>
      </>
    );
  };

  showSummaryData = () => {
    return (
      <>
        {this.state.showFullSummary && (
          <div className="fullSummaryDiv">
            <div className="summary-div">
              <span className="summary-text">
                {this.context.translate("_FULL_SUMMARY_")}
              </span>
            </div>

            <div className="summary-start-location">
              <div className="summary-start-location-div">
                <div className="title">
                  {" "}
                  {this.context.translate("_START_LOCATION_")}
                </div>
                <Image src={summarystartloc} />
              </div>

              <span className="value">
                {this.vehicleOtherInfoStore?.vehiclesHistData?.startLocation}
              </span>
            </div>

            <div className="summary-end-location">
              <div className="summary-end-location-div">
                <div className="title">
                  {this.context.translate("_FINISH_LOCATION_")}
                </div>
                <Image src={summaryendloc} />
              </div>

              <span className="value">
                {this.vehicleOtherInfoStore.vehiclesHistData?.stopLocation}
              </span>
            </div>

            <div className="summary-work-time">
              <div className="summary-work-time-div">
                <div className="title">
                  {this.context.translate("_WORK_TIME_")}
                </div>
                <Image src={workTimeIcon} />
              </div>

              <span className="value">
                {" "}
                {this.vehicleOtherInfoStore?.vehiclesHistData?.travelduration}
              </span>
            </div>

            <div className="summary-work-time">
              <div className="summary-work-time-div">
                <div className="title">
                  {this.context.translate("_FLEET_STOP_TIME_")}
                </div>
                <Image src={stopTimeIcon} />
              </div>

              <span className="value">
                {this.vehicleOtherInfoStore?.vehiclesHistData?.stopduration}
              </span>
            </div>

            <div className="summary-mileage">
              <div className="summary-mileage-div">
                <div className="title">
                  {this.context.translate("_MILEAGE_")}
                </div>
                <Image src={mapIcon} />
              </div>

              <span className="value">
                {this.vehicleOtherInfoStore?.vehiclesHistData?.distanceTravel?.toFixed(
                  2
                )}
              </span>
            </div>
          </div>
        )}
        {this.vehicleOtherInfoStore?.vehicleSummaryData?.map((val) => (
          <div className="summary-main">
            <div
              className="summary-click"
              onClick={async () => {
                // await this.clearMap();
                this.vehicleOtherInfoStore.histTrackingClickPolylineObj = [];
                this.vehicleOtherInfoStore.timeWisePolylineArray = [];
                this.vehicleOtherInfoStore.idleAndStopPointsArray = [];
                if (this.polyline2) {
                  this.props.This.mapRef.current.removeLayer(this.polyline2);
                }
                await this.vehicleOtherInfoStore.getHistoryTrackingData({
                  vehicleId: this.props.info.vehicleId,
                  companyId: this.props.info.companyId,
                  fromDate: val.startTime,
                  toDate: val.stopTime,
                });

                await this.showPolyline();
                await this.setState({ update: 1 });
              }}
            >
              <div className="summary-div">
                <span className="summary-text">
                  {this.context.translate("_SUMMARY_")}
                </span>
              </div>

              <div className="summary-start-location">
                <div className="summary-start-location-div">
                  <div className="title">
                    {" "}
                    {this.context.translate("_START_LOCATION_")}
                  </div>
                  <Image src={summarystartloc} />
                </div>

                <span className="value">{val.startLocation}</span>
              </div>

              <div className="summary-end-location">
                <div className="summary-end-location-div">
                  <div className="title">
                    {this.context.translate("_FINISH_LOCATION_")}
                  </div>
                  <Image src={summaryendloc} />
                </div>

                <span className="value">{val.stopLocation}</span>
              </div>

              <div className="summary-work-time">
                <div className="summary-work-time-div">
                  <div className="title">
                    {this.context.translate("_WORK_TIME_")}
                  </div>
                  <Image src={workTimeIcon} />
                </div>

                <span className="value">
                  {" "}
                  {val.travelduration >= 3
                    ? val.travelduration.toFixed(2)
                    : val?.travelduration}
                </span>
              </div>

              <div className="summary-work-time">
                <div className="summary-work-time-div">
                  <div className="title">
                    {this.context.translate("_FLEET_STOP_TIME_")}
                  </div>
                  <Image src={stopTimeIcon} />
                </div>

                <span className="value">{val?.stopduration}</span>
              </div>

              <div className="summary-mileage">
                <div className="summary-mileage-div">
                  <div className="title">
                    {this.context.translate("_MILEAGE_")}
                  </div>
                  <Image src={mapIcon} />
                </div>

                <span className="value">{val.distanceTravel}</span>
              </div>

              <div className="summary-date">
                <span className="summary-text">{val?.sTime}</span>
              </div>
            </div>
            {val?.tripData &&
              val?.tripData?.map((trip, ind) => (
                <div className="summary-trip-block">
                  <div className="summary-trip-duration-block">
                    {ind === 0 ? (
                      <div
                        onClick={async () => {
                          // await this.clearMap();
                          this.vehicleOtherInfoStore.timeWisePolylineArray = [];
                          const resp =
                            await this.vehicleOtherInfoStore.getHistoryTrackingData2(
                              {
                                vehicleId: this.props.info.vehicleId,
                                companyId: this.props.info.companyId,
                                fromDate: trip.startTime,
                                toDate: trip.stopTime,
                              }
                            );

                          resp > 0 && (await this.showTrackingPolyline());
                          // await this.showTrackingPolyline();
                          await this.setState({
                            update: 1,
                          });
                        }}
                      >
                        <div className="duration-row">
                          <div className="d-flex gap-2">
                            <p className="statusStop" style={{ width: "40px" }}>
                              00:00
                            </p>
                            <p className="duration-text">
                              {this.context.translate("_STOP_DURATION_")}
                            </p>
                          </div>
                          <p>{this.convertToFormattedTime(trip.stopSince)}</p>
                        </div>

                        <div className="duration-row">
                          <div className="d-flex gap-2">
                            <p
                              className="statusStart"
                              style={{ width: "40px" }}
                            >
                              {trip.startTime.split(" ")[1].slice(0, 5)}

                              <br />
                              {this.context.translate("_START_")}
                            </p>

                            <p className="duration-text">
                              {this.context.translate("_DRIVING_DURATION_")}
                              <br />
                              {this.context.translate("_MILEAGE_")}
                            </p>
                          </div>
                          <p>
                            {this.convertToFormattedTime(trip.startTill)}
                            <br />
                            {trip.distanceTravelled}Km
                          </p>
                        </div>

                        <div className="duration-row">
                          <div className="d-flex gap-2">
                            <p className="statusStop" style={{ width: "40px" }}>
                              {trip.stopTime
                                ? trip.stopTime?.split(" ")[1].slice(0, 5)
                                : "00:00"}
                            </p>
                            <p className="duration-text">
                              {this.context.translate("_STOP_DURATION_")}
                            </p>
                          </div>
                          <p>{this.convertToFormattedTime(trip.stopTill)}</p>
                        </div>
                      </div>
                    ) : (
                      <div
                        onClick={async () => {
                          this.vehicleOtherInfoStore.timeWisePolylineArray = [];
                          await this.props.This.setState({
                            update: 1,
                          });
                          // await this.showTrackingPolyline();
                          const resp =
                            await this.vehicleOtherInfoStore.getHistoryTrackingData2(
                              {
                                vehicleId: this.props.info.vehicleId,
                                companyId: this.props.info.companyId,
                                fromDate: trip.startTime,
                                toDate: trip.stopTime,
                              }
                            );

                          resp > 0
                            ? await this.showTrackingPolyline()
                            : (this.vehicleOtherInfoStore.timeWisePolylineArray =
                              []);
                        }}
                      >
                        <div className="duration-row">
                          <div className="d-flex gap-2">
                            <p
                              className="statusStart"
                              style={{ width: "40px" }}
                            >
                              {trip.startTime?.split(" ")[1].slice(0, 5)}
                              <br />
                              {this.context.translate("_START_")}
                            </p>
                            <p className="duration-text">
                              {this.context.translate("_DRIVING_DURATION_")}
                              <br />
                              {this.context.translate("_MILEAGE_")}
                            </p>
                          </div>

                          <p>
                            {this.convertToFormattedTime(trip.startTill)}
                            <br />
                            {trip?.distanceTravelled}Km
                          </p>
                        </div>

                        <div className="duration-row">
                          <div className="d-flex gap-2">
                            <p className="statusStop" style={{ width: "40px" }}>
                              {trip.stopTime?.split(" ")[1].slice(0, 5)}
                              <br />
                              {this.context.translate("_STOP_")}
                            </p>
                            <p className="duration-text">
                              {this.context.translate("_STOP_DURATION_")}
                            </p>
                          </div>

                          <p>{this.convertToFormattedTime(trip.stopTill)}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
          </div>
        ))}
      </>
    );
  };

  showStatusOfVehiclePro = () => {
    const record = this.props.info;
    const statusData = this.vehicleOtherInfoStore?.statusData;

    const lastReportingTime = record.updatedate;
    const serverCurrentTime = record.currtime;

    let diff = dayjs(serverCurrentTime) - dayjs(lastReportingTime);
    diff /= 60000; // minutes

    let statusText = "--";

    if (record.vehiclestatus === "expired") {
      statusText = this.context.translate("_EXPIRED_");
    } else if (diff >= 90) {
      statusText = `${this.context.translate("_NOT_REPORTING_SINCE_")}: ${statusData?.nodataSince != null
        ? this.formatTime(statusData.nodataSince)
        : "--"
        }`;
    } else if (record.acc === 1 && record.speed === 0) {
      statusText = `${this.context.translate("_IDLE_SINCE_")}: ${statusData?.idleSince != null
        ? this.formatTime(statusData.idleSince)
        : this.getDateDiff(record.currtime, record.updatedate)
        }`;
    } else if (record.acc === 0 || record.acc == null) {
      statusText = `${this.context.translate("_STOP_SINCE_")}: ${statusData?.stopSince != null
        ? this.formatTime(statusData.stopSince)
        : "--"
        }`;
    } else if (record.acc === 1 && record.speed > 0) {
      statusText = `${this.context.translate("_RUNNING_SINCE_")}: ${statusData?.runSince != null
        ? this.formatTime(statusData.runSince)
        : "--"
        }`;
    }

    return (
      <Spin size="small" spinning={this.vehicleOtherInfoStore.loading}>
        {statusText}
      </Spin>
    );
  };

  showStatusOfVehicle = () => {
    const record = this.props.info;

    const lastReportingTime = record.updatedate;
    const serverCurrentTime = record.currtime;

    let diff = dayjs(serverCurrentTime) - dayjs(lastReportingTime);
    diff /= 60000; // minutes

    if (record.vehiclestatus === "expired") {
      return this.context.translate("_EXPIRED_");
    }

    if (diff >= 90) {
      return `${this.context.translate("_NOT_REPORTING_SINCE_")}: ${record.nodataSince != null ? this.formatTime(record.nodataSince) : "--"
        }`;
    }

    if (record.acc === 1 && record.speed === 0) {
      return `${this.context.translate("_IDLE_SINCE_")}: ${record.idleSince != null
        ? this.formatTime(record.idleSince)
        : this.getDateDiff(record.currtime, record.updatedate)
        }`;
    }

    if (record.acc === 0 || record.acc == null) {
      return `${this.context.translate("_STOP_SINCE_")}: ${record.stopSince != null ? this.formatTime(record.stopSince) : "--"
        }`;
    }

    if (record.acc === 1 && record.speed > 0) {
      return `${this.context.translate("_RUNNING_SINCE_")}: ${record.runSince != null ? this.formatTime(record.runSince) : "--"
        }`;
    }

    return "--";
  };

  handleObdData = async () => {
    const data = await this.vehicleOtherInfoStore.getObdData(this.props.info.vehicleId)
    // console.log(data, "data")
    await this.setState({ showObdData: data ? data : [] })
  }

  render() {
    const carImage = this.getStatusWiseCarImage();
    const graphData = this.vehicleOtherInfoStore.fuelRefillData;

    const hasData = graphData && graphData.length > 0;

    return (
      <>
        <Card className="vehicleInfoCard">
          <div style={{ height: "100%" }}>
            <div className="vehicleInfoCardInnerContent">
              <span className="vehicleInfoCardVehicleNo">
                <AntTooltip
                  title={this.props.info.vehicleNo}
                  placement="bottom"
                >
                  {this.props.info.vehicleNo}
                </AntTooltip>
              </span>
              <div style={{ display: "flex", gap: "12px" }}>
                <div className="vehicleInfoCardGps">
                  <Image
                    src={wifiIcon}
                    style={{ width: "16px", height: "16px" }}
                  />
                  <span className="vehicleInfoCardGpsText">GPS</span>
                </div>

                <div className="vehicleInfoCardGps">
                  <Image
                    src={networkIcon}
                    style={{ width: "16px", height: "16px" }}
                  />
                  <span className="vehicleInfoCardNetworkText">Network</span>
                </div>

                <CloseOutlined
                  onClick={async () => {
                    await this.props.This.setState({
                      vehicleOtherInfo: false,
                      selectedVehicleId: null,
                    });
                    await this.props.closeMapModal();
                    await this.clearFuelIcons();
                    // await this.clearMap();
                    await this.clearNewMap();
                  }}
                />
              </div>
            </div>

            <div
              style={{
                height: "25%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Image
                // src={require("../assets/images/NewDesign/livetracking/car-trans1-1.png")}
                src={carImage}
                style={{ width: "100%", height: "131px", marginTop: "12px" }}
              />
            </div>
            <div style={{ height: "70%" }}>
              <Tabs
                onChange={this.handleTabChange}
                className="vehicleInfoCardTabs"
                items={[
                  {
                    label: (
                      <Avatar
                        className="tabsImageStyle"
                        src={
                          this.state.activeTab === "1"
                            ? infocircleblue
                            : infocircle
                        }
                      />
                    ),
                    key: "1",
                    children: (
                      <>
                        <div className="vehicleInfoMainScreen">
                          <div className="vehicleInfoCardTab1stRow">
                            <div className="vehicleInfoCardTab1stRowLeftGroup">
                              <div
                                className={`status-wrapper ${this.getStatusColorClass(
                                  this.props.info.currentStatus
                                )}`}
                              >
                                <i className="bi bi-circle-fill"></i>
                                {this.props.info.currentStatus}
                              </div>
                            </div>
                            {/* <Spin size="small" spinning={this.state.loading}> */}
                            <span className="vehicleInfoCardTab1stRowRightText">
                              {config.pythonReport === 1
                                ? this.showStatusOfVehiclePro()
                                : this.showStatusOfVehicle()}
                              {/* <Spin
                                size="small"
                                spinning={this.vehicleOtherInfoStore.loading}
                              >
                                {(() => {
                                  const record = this.props.info;

                                  const statusData =
                                    this.vehicleOtherInfoStore?.statusData;
                                  const lastReportingTime = record.updatedate;
                                  const serverCurrentTime = record.currtime;
                                  let diff =
                                    dayjs(serverCurrentTime) -
                                    dayjs(lastReportingTime);
                                  diff /= 60000; // in minutes

                                  if (record.vehiclestatus === "expired") {
                                    return this.context.translate("_EXPIRED_");
                                  } else if (diff >= 90) {
                                    return `${this.context.translate(
                                      "_NOT_REPORTING_SINCE_"
                                    )}: ${
                                      statusData?.nodataSince != null
                                        ? this.formatTime(
                                            statusData.nodataSince
                                          )
                                        : "--"
                                    }`;
                                  } else if (
                                    record.acc === 1 &&
                                    record.speed === 0
                                  ) {
                                    return `${this.context.translate(
                                      "_IDLE_SINCE_"
                                    )}: ${
                                      statusData?.idleSince != null
                                        ? this.formatTime(statusData.idleSince)
                                        : this.getDateDiff(
                                            record.currtime,
                                            record.updatedate
                                          )
                                    }`;
                                  } else if (
                                    record.acc === 0 ||
                                    record.acc == null
                                  ) {
                                    return `${this.context.translate(
                                      "_STOP_SINCE_"
                                    )}: ${
                                      statusData?.stopSince != null
                                        ? this.formatTime(statusData.stopSince)
                                        : "--"
                                    }`;
                                  } else if (
                                    record.acc === 1 &&
                                    record.speed > 0
                                  ) {
                                    return `${this.context.translate(
                                      "_RUNNING_SINCE_"
                                    )}: ${
                                      statusData?.runSince != null
                                        ? this.formatTime(statusData.runSince)
                                        : "--"
                                    }`;
                                  } else {
                                    return "--";
                                  }
                                })()}
                              </Spin> */}
                              {/* {(() => {
                                const record = this.props.info;

                                const lastReportingTime = record.updatedate;
                                const serverCurrentTime = record.currtime;
                                let diff =
                                  dayjs(serverCurrentTime) -
                                  dayjs(lastReportingTime);
                                diff /= 60000; // in minutes

                                if (record.vehiclestatus === "expired") {
                                  return this.context.translate("_EXPIRED_");
                                } else if (diff >= 90) {
                                  return `${this.context.translate(
                                    "_NOT_REPORTING_SINCE_"
                                  )}: ${
                                    record.nodataSince != null
                                      ? this.formatTime(record.nodataSince)
                                      : "--"
                                  }`;
                                } else if (
                                  record.acc === 1 &&
                                  record.speed === 0
                                ) {
                                  return `${this.context.translate(
                                    "_IDLE_SINCE_"
                                  )}: ${
                                    record.idleSince != null
                                      ? this.formatTime(record.idleSince)
                                      : this.getDateDiff(
                                          record.currtime,
                                          record.updatedate
                                        )
                                  }`;
                                } else if (
                                  record.acc === 0 ||
                                  record.acc == null
                                ) {
                                  return `${this.context.translate(
                                    "_STOP_SINCE_"
                                  )}: ${
                                    record.stopSince != null
                                      ? this.formatTime(record.stopSince)
                                      : "--"
                                  }`;
                                } else if (
                                  record.acc === 1 &&
                                  record.speed > 0
                                ) {
                                  return `${this.context.translate(
                                    "_RUNNING_SINCE_"
                                  )}: ${
                                    record.runSince != null
                                      ? this.formatTime(record.runSince)
                                      : "--"
                                  }`;
                                } else {
                                  return "--";
                                }
                              })()} */}
                            </span>
                            {/* </Spin> */}
                          </div>

                          <div className="vehicle-info-location">
                            <div className="locationRow">
                              <span className="locationHeading">
                                {this.context.translate("_LOCATION_")}
                              </span>
                              <Image src={locationIcon} />
                            </div>

                            <span className="vehicle-address">
                              {this.props.info.formatted_address}
                            </span>
                          </div>

                          <div className="vehicle-info-lat-lng">
                            <span className="vehicle-lat-lng">
                              {this.props.info.latitude
                                ? parseFloat(this.props.info.latitude).toFixed(
                                  7
                                )
                                : ""}
                              ,
                              {this.props.info.longitude
                                ? parseFloat(this.props.info.longitude).toFixed(
                                  7
                                )
                                : ""}
                            </span>
                            <Image src={latlngIcon} />
                          </div>

                          <div className="vehicleNoDiv">
                            <div className="lastSignalDurationText">
                              {this.context.translate("_VEHICLE_NO_")}
                            </div>
                            <small>{this.props.info.vehicleNo}</small>
                          </div>

                          <div className="currentStatusDiv">
                            <span className="currentStatusText">
                              {" "}
                              {this.context.translate("_CURRENT_STATUS_")}
                            </span>

                            <span className="currentStatusValue">
                              {this.props.info.currentStatus}
                              {this.props.info.currentStatus === "Running"
                                ? "(" +
                                Math.floor(this.props.info.speed) +
                                " Km/h)"
                                : ""}
                            </span>
                          </div>

                          <div className="stateDurationDiv">
                            <span className="stateDurationText">
                              {" "}
                              {this.context.translate("_STATE_DURATION_")}
                            </span>

                            <span className="stateDurationValue">
                              {config.project === "proawtltrack" ? (
                                <Spin
                                  size="small"
                                  spinning={this.vehicleOtherInfoStore.loading}
                                >
                                  {this.stautsWiseData()}
                                </Spin>
                              ) : (
                                this.calculateDays()
                              )}
                            </span>
                          </div>

                          <div className="lastSignalDuration">
                            <div className="lastSignalDurationText">
                              {this.context.translate("_LAST_SIGNAL_SYNC_")}
                            </div>
                            {/* <small>{this.props.info.updatedate}</small> */}
                            <small>
                              {config.project === "proawtltrack"
                                ? dayjs
                                  .utc(this.props.info.updatedate)
                                  .format("DD-MM-YYYY | hh:mm:ss A")
                                : dayjs(this.props.info.updatedate).format(
                                  "DD-MM-YYYY | hh:mm:ss A"
                                )}
                            </small>
                          </div>

                          <div className="fuelDiv">
                            <span className="fuelDivText">
                              <span>{this.context.translate("_FUEL_")}</span>
                            </span>
                            <span className="fuelDivValue">
                              {this.props.info.fuelHeight1} Liters
                            </span>
                          </div>

                          <div className="currentSpeedDiv">
                            <div className="currentSpeedRow">
                              <span className="currentSpeedText">
                                {this.context.translate("_CURRENT_SPEED_")}
                              </span>
                              <Image src={Speedometer} />
                            </div>

                            <span className="currentSpeedValue">
                              {this.props.info.speed} KMPH
                            </span>
                          </div>

                          {/* <div className="currentSpeedDiv">
                            <div className="currentSpeedRow">
                              <span className="currentSpeedText">Mileage</span>
                              <Image src={mapIcon} />
                            </div>

                            <span className="mileageValue">48 km</span>
                          </div> */}

                          <div className="odometerDiv">
                            <div className="odometer1stRow">
                              <span className="odometerText">
                                {this.context.translate(
                                  "_FLEET_DASHBORD_SETTING_ODOMETER_"
                                )}
                              </span>
                              <Image
                                src={odometerIcon}
                                style={{ height: "22px", width: "22px" }}
                              />
                            </div>
                            <div>
                              <span className="odometerValue">
                                {this.props.info.odometer
                                  ? this.props.info.odometer
                                  : 0}
                              </span>
                            </div>
                          </div>

                          <div className="ignitionDiv">
                            <div className="ignitionRow">
                              <span className="currentSpeedText">
                                {this.context.translate("_POWER_")}
                              </span>
                              <Image
                                style={{ height: "20px", width: "20px" }}
                                src={
                                  this.props.info.power === 0
                                    ? powerIconGreen
                                    : this.props.info.power === 1
                                      ? powerIconRed
                                      : powerIconGray
                                }
                              />
                            </div>
                          </div>
                          {this.props.info.batteryVoltage != null && (
                            <div className="currentStatusDiv">
                              <span className="currentStatusText">
                                {" "}
                                {this.context.translate("_BATTERY_VOLTAGE_")}
                              </span>

                              <span className="currentStatusValue">
                                {this.props.info.batteryVoltage}
                              </span>
                            </div>
                          )}

                          {this.props.info.externalVoltage != null && (
                            <div className="currentStatusDiv">
                              <span className="currentStatusText">
                                {" "}
                                {this.context.translate("_EXTERNAL_VOLTAGE_")}
                              </span>

                              <span className="currentStatusValue">
                                {this.props.info.externalVoltage}
                              </span>
                            </div>
                          )}

                          <div className="fuelDiv">
                            <span className="fuelDivText">
                              <span>
                                {this.context.translate("_BLE_TEMP_")}
                              </span>
                            </span>
                            <span className="fuelDivValue">
                              {this.bleTempValues(this.props.info)}
                            </span>
                          </div>

                          <div className="fuelDiv">
                            <span className="fuelDivText">
                              <span>
                                {this.context.translate("_BLE_HUMIDITY_")}
                              </span>
                            </span>
                            <span className="fuelDivValue">
                              {this.bleHumidityValues(this.props.info)}
                            </span>
                          </div>

                          <div className="fuelDiv">
                            <span className="fuelDivText">
                              <span>
                                {this.context.translate("_TOTAL_WEIGHT_")}
                              </span>
                            </span>
                            <span className="fuelDivValue">
                              {this.totalWeight(this.props.info)}
                            </span>
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    label: (
                      <Avatar
                        className="tabsImageStyle"
                        src={
                          this.state.activeTab === "2"
                            ? clockhistoryblue
                            : clockhistory
                        }
                        onClick={async () => {
                          this.vehicleOtherInfoStore.timeWisePolylineArray = [];

                          this.vehicleOtherInfoStore.offlineDataNewObj = [];
                          this.vehicleOtherInfoStore.idleAndStopPointsArray =
                            [];

                          await this.clearFuelIcons();

                          this.props.This.setIntervals();
                          await this.getVehicleHistInfo();

                          await this.getVehicleOffilneInfo(0);
                          await this.showPolyline();
                        }}
                      />
                    ),
                    key: "2",
                    children: (
                      <>
                        <RangePicker
                          className="histdatePicker"
                          allowClear={false}
                          format="YYYY-MM-DD"
                          size="small"
                          showTime={false}
                          presets={this.rangePresets.items}
                          onChange={this.onRangeChange}
                          style={{ width: "97%" }}
                          defaultValue={[dayjs().startOf("day"), dayjs()]}
                        />

                        {config.pythonReport === 1
                          ? this.showProAwtlSummary()
                          : this.showSummaryData()}
                        {/* <Spin spinning={this.vehicleOtherInfoStore.loading}>
                          {this.state.showFullSummary && (
                            <div className="fullSummaryDiv">
                              <div className="summary-div">
                                <span className="summary-text">
                                  {this.context.translate("_FULL_SUMMARY_")}
                                </span>
                              </div>

                              <div className="summary-start-location">
                                <div className="summary-start-location-div">
                                  <div className="title">
                                    {" "}
                                    {this.context.translate("_START_LOCATION_")}
                                  </div>
                                  <Image src={summarystartloc} />
                                </div>

                                <span className="value">
                                  {
                                    this.vehicleOtherInfoStore?.vehiclesHistData
                                      ?.startLocation
                                  }
                                </span>
                              </div>

                              <div className="summary-end-location">
                                <div className="summary-end-location-div">
                                  <div className="title">
                                    {this.context.translate(
                                      "_FINISH_LOCATION_"
                                    )}
                                  </div>
                                  <Image src={summaryendloc} />
                                </div>

                                <span className="value">
                                  {
                                    this.vehicleOtherInfoStore.vehiclesHistData
                                      ?.stopLocation
                                  }
                                </span>
                              </div>

                              <div className="summary-work-time">
                                <div className="summary-work-time-div">
                                  <div className="title">
                                    {this.context.translate("_WORK_TIME_")}
                                  </div>
                                  <Image src={workTimeIcon} />
                                </div>

                                <span className="value">
                                  {" "}
                                 
                                  {
                                    this.vehicleOtherInfoStore?.vehiclesHistData
                                      ?.travelduration
                                  }
                                </span>
                              </div>

                              <div className="summary-work-time">
                                <div className="summary-work-time-div">
                                  <div className="title">
                                    {this.context.translate(
                                      "_FLEET_STOP_TIME_"
                                    )}
                                  </div>
                                  <Image src={stopTimeIcon} />
                                </div>

                                <span className="value">
                                  
                                  {
                                    this.vehicleOtherInfoStore?.vehiclesHistData
                                      ?.stopduration
                                  }
                                </span>
                              </div>

                              <div className="summary-mileage">
                                <div className="summary-mileage-div">
                                  <div className="title">
                                    {this.context.translate("_MILEAGE_")}
                                  </div>
                                  <Image src={mapIcon} />
                                </div>

                                <span className="value">
                                  {this.vehicleOtherInfoStore?.vehiclesHistData?.distanceTravel?.toFixed(
                                    2
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                          {this.vehicleOtherInfoStore?.vehicleSummaryData?.map(
                            (val) => (
                              <div
                                className="summary-main"
                                onClick={async () => {
                                  // await this.clearMap();
                                  this.vehicleOtherInfoStore.histTrackingClickPolylineObj =
                                    [];
                                  this.vehicleOtherInfoStore.timeWisePolylineArray =
                                    [];
                                  this.vehicleOtherInfoStore.idleAndStopPointsArray =
                                    [];
                                  if (this.polyline2) {
                                    this.props.This.mapRef.current.removeLayer(
                                      this.polyline2
                                    );
                                  }
                                  await this.vehicleOtherInfoStore.getHistoryTrackingData(
                                    {
                                      vehicleId: this.props.info.vehicleId,
                                      companyId: this.props.info.companyId,
                                      fromDate: val.startTime,
                                      toDate: val.stopTime,
                                    }
                                  );

                                  await this.showPolyline();
                                  await this.setState({ update: 1 });
                                }}
                              >
                                <div className="summary-div">
                                  <span className="summary-text">
                                    {this.context.translate("_SUMMARY_")}
                                  </span>
                                </div>

                                <div className="summary-start-location">
                                  <div className="summary-start-location-div">
                                    <div className="title">
                                      {" "}
                                      {this.context.translate(
                                        "_START_LOCATION_"
                                      )}
                                    </div>
                                    <Image src={summarystartloc} />
                                  </div>

                                  <span className="value">
                                    {val.startLocation}
                                  </span>
                                </div>

                                <div className="summary-end-location">
                                  <div className="summary-end-location-div">
                                    <div className="title">
                                      {this.context.translate(
                                        "_FINISH_LOCATION_"
                                      )}
                                    </div>
                                    <Image src={summaryendloc} />
                                  </div>

                                  <span className="value">
                                    {val.stopLocation}
                                  </span>
                                </div>

                                <div className="summary-work-time">
                                  <div className="summary-work-time-div">
                                    <div className="title">
                                      {this.context.translate("_WORK_TIME_")}
                                    </div>
                                    <Image src={workTimeIcon} />
                                  </div>

                                  <span className="value">
                                    {" "}
                                    {val.travelduration >= 3
                                      ? val.travelduration.toFixed(2)
                                      : val?.travelduration}
                                  </span>
                                </div>

                                <div className="summary-work-time">
                                  <div className="summary-work-time-div">
                                    <div className="title">
                                      {this.context.translate(
                                        "_FLEET_STOP_TIME_"
                                      )}
                                    </div>
                                    <Image src={stopTimeIcon} />
                                  </div>

                                  <span className="value">
                                    {val?.stopduration}
                                  </span>
                                </div>

                                <div className="summary-mileage">
                                  <div className="summary-mileage-div">
                                    <div className="title">
                                      {this.context.translate("_MILEAGE_")}
                                    </div>
                                    <Image src={mapIcon} />
                                  </div>

                                  <span className="value">
                                    {val.distanceTravel}
                                  </span>
                                </div>

                                <div className="summary-date">
                                  <span className="summary-text">
                                    {val?.sTime}
                                  </span>
                                </div>

                                {val?.tripData &&
                                  val?.tripData?.map((trip, ind) => (
                                    <div className="summary-trip-block">
                                      <div className="summary-trip-duration-block">
                                        {ind === 0 ? (
                                          <div
                                            onClick={async () => {
                                              // await this.clearMap();
                                              this.vehicleOtherInfoStore.timeWisePolylineArray =
                                                [];
                                              const resp =
                                                await this.vehicleOtherInfoStore.getHistoryTrackingData2(
                                                  {
                                                    vehicleId:
                                                      this.props.info.vehicleId,
                                                    companyId:
                                                      this.props.info.companyId,
                                                    fromDate: trip.startTime,
                                                    toDate: trip.stopTime,
                                                  }
                                                );

                                              resp > 0 &&
                                                (await this.showTrackingPolyline());
                                              // await this.showTrackingPolyline();
                                              await this.setState({
                                                update: 1,
                                              });
                                            }}
                                          >
                                            <div className="duration-row">
                                              <div className="d-flex gap-2">
                                                <p
                                                  className="statusStop"
                                                  style={{ width: "40px" }}
                                                >
                                                  00:00
                                                 
                                                </p>
                                                <p className="duration-text">
                                                  {this.context.translate(
                                                    "_STOP_DURATION_"
                                                  )}
                                                </p>
                                              </div>
                                              <p>
                                                {this.convertToFormattedTime(
                                                  trip.stopSince
                                                )}
                                              </p>
                                            </div>

                                            <div className="duration-row">
                                              <div className="d-flex gap-2">
                                                <p
                                                  className="statusStart"
                                                  style={{ width: "40px" }}
                                                >
                                                  {trip.startTime
                                                    .split(" ")[1]
                                                    .slice(0, 5)}

                                                  <br />
                                                  {this.context.translate(
                                                    "_START_"
                                                  )}
                                                </p>

                                                <p className="duration-text">
                                                  {this.context.translate(
                                                    "_DRIVING_DURATION_"
                                                  )}
                                                  <br />
                                                  {this.context.translate(
                                                    "_MILEAGE_"
                                                  )}
                                                </p>
                                              </div>
                                              <p>
                                                {this.convertToFormattedTime(
                                                  trip.startTill
                                                )}
                                                <br />
                                                {trip.distanceTravelled}Km
                                              </p>
                                            </div>

                                            <div className="duration-row">
                                              <div className="d-flex gap-2">
                                                <p
                                                  className="statusStop"
                                                  style={{ width: "40px" }}
                                                >
                                                  {trip.stopTime
                                                    ? trip.stopTime
                                                        ?.split(" ")[1]
                                                        .slice(0, 5)
                                                    : "00:00"}

                                                 
                                                </p>
                                                <p className="duration-text">
                                                  {this.context.translate(
                                                    "_STOP_DURATION_"
                                                  )}
                                                </p>
                                              </div>
                                              <p>
                                                {this.convertToFormattedTime(
                                                  trip.stopTill
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        ) : (
                                          <div
                                            onClick={async () => {
                                              this.vehicleOtherInfoStore.timeWisePolylineArray =
                                                [];
                                              await this.props.This.setState({
                                                update: 1,
                                              });
                                              // await this.showTrackingPolyline();
                                              const resp =
                                                await this.vehicleOtherInfoStore.getHistoryTrackingData2(
                                                  {
                                                    vehicleId:
                                                      this.props.info.vehicleId,
                                                    companyId:
                                                      this.props.info.companyId,
                                                    fromDate: trip.startTime,
                                                    toDate: trip.stopTime,
                                                  }
                                                );

                                              resp > 0
                                                ? await this.showTrackingPolyline()
                                                : (this.vehicleOtherInfoStore.timeWisePolylineArray =
                                                    []);
                                            }}
                                          >
                                            <div className="duration-row">
                                              <div className="d-flex gap-2">
                                                <p
                                                  className="statusStart"
                                                  style={{ width: "40px" }}
                                                >
                                                  {trip.startTime
                                                    ?.split(" ")[1]
                                                    .slice(0, 5)}
                                                  <br />
                                                  {this.context.translate(
                                                    "_START_"
                                                  )}
                                                </p>
                                                <p className="duration-text">
                                                  {this.context.translate(
                                                    "_DRIVING_DURATION_"
                                                  )}
                                                  <br />
                                                  {this.context.translate(
                                                    "_MILEAGE_"
                                                  )}
                                                </p>
                                              </div>

                                              <p>
                                                {this.convertToFormattedTime(
                                                  trip.startTill
                                                )}
                                                <br />
                                                {trip?.distanceTravelled}Km
                                              </p>
                                            </div>

                                            <div className="duration-row">
                                              <div className="d-flex gap-2">
                                                <p
                                                  className="statusStop"
                                                  style={{ width: "40px" }}
                                                >
                                                  {trip.stopTime
                                                    ?.split(" ")[1]
                                                    .slice(0, 5)}
                                                  <br />
                                                  {this.context.translate(
                                                    "_STOP_"
                                                  )}
                                                </p>
                                                <p className="duration-text">
                                                  {this.context.translate(
                                                    "_STOP_DURATION_"
                                                  )}
                                                </p>
                                              </div>

                                              <p>
                                                {this.convertToFormattedTime(
                                                  trip.stopTill
                                                )}
                                              </p>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            )
                          )}
                        </Spin> */}
                      </>
                    ),
                  },
                  {
                    label: (
                      <Avatar
                        className="tabsImageStyle"
                        src={
                          this.state.activeTab === "3"
                            ? exclamationcircleblue
                            : exclamationcircle
                        }
                        onClick={async () => {
                          await this.getVehicleAlertInfo();
                        }}
                      />
                    ),
                    key: "3",
                    children: this.vehicleOtherInfoStore.loading ? (
                      <div className="tab-spin-center">
                        <Spin />
                      </div>
                    ) : (
                      <>
                        {this.vehicleOtherInfoStore.ruleCount == 0 ? (
                          <div className="alert-msg">
                            {this.context.translate("_NO_DATA_AVAILABLE_")}
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "10px",
                            }}
                          >
                            {this.vehicleOtherInfoStore.vehiclesTriggerData.map(
                              (val) => (
                                <div className="alerts-main-div">
                                  <div className="alerts-div">
                                    <span className="alerts-title">
                                      {/* Overspeed */}
                                      {val.ruleselector}
                                    </span>
                                    <Image
                                      src={alertIcon}
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                      }}
                                    />
                                  </div>

                                  <div className="alerts-location">
                                    {val.Address}
                                    {/* Halwan Suburb - Sharjah - UAE */}
                                  </div>

                                  <div className="alerts-date">
                                    {val.Time}
                                    {/* 08/09/2024 | 4:22:16 PM */}
                                  </div>
                                </div>
                              )
                            )}
                          </div>
                        )}{" "}
                      </>
                    ),
                  },
                  {
                    label: (
                      <Avatar
                        className="tabsImageStyle"
                        src={
                          this.state.activeTab === "4"
                            ? clipboarddatablue
                            : clipboardIcon
                        }
                        onClick={async () => {

                          const daySummary =
                            await this.vehicleOtherInfoStore.daySummary({
                              currentDate: dayjs().format("YYYY-MM-DD"),
                              companyId: this.props.info.companyId,
                              vehicleId: [this.props.info.vehicleId],
                            });
                          const driverPerformance =
                            await this.vehicleOtherInfoStore.getDriverPerformance(
                              {
                                currentDate: dayjs().format("YYYY-MM-DD"),
                                companyId: this.props.info.companyId,
                                driverId: this.props.info.driverId,
                              }
                            );

                          this.setState({
                            daySummary: daySummary,
                            driverPerformance: driverPerformance,
                            loadData: 1,
                          });
                        }}
                      />
                    ),
                    key: "4",
                    children: (
                      <>
                        {/* {this.activityTab()} */}
                        {config.project == "proawtltrack"
                          ? this.activityTabAWTL()
                          : this.activityTab()}
                      </>
                    ),
                  },
                  {
                    label: (
                      <Avatar
                        className="tabsImageStyle"
                        src={
                          this.state.activeTab === "5" ? fuelpumpblue : fuelpump
                        }
                        onClick={async () => {
                          this.vehicleOtherInfoStore.timeWisePolylineArray = [];

                          this.vehicleOtherInfoStore.offlineDataNewObj = [];
                          this.vehicleOtherInfoStore.idleAndStopPointsArray =
                            [];
                          this.setState({ selectedIndex: null });
                          this.props.This.clearIntervals();
                          await this.getFuelRefillInfo();
                          await this.getVehicleHistInfo();

                          await this.getVehicleOffilneInfo(1);

                          await this.showFuelIcons();

                          await this.showPolyline();
                        }}
                      />
                    ),
                    key: "5",
                    children: (
                      <>
                        <div className="fuelTab">
                          <div className="fuel-graph">
                            <FuelGraphLivetracking
                              fuelGraphData={this.state.graphData}
                              graphData={this.state.fuelRefillData}
                              selectedFuelData={this.state.selectedData}
                              mapRef={this.props.This.mapRef}
                            />
                          </div>
                          <RangePicker
                            className="histdatePicker"
                            allowClear={false}
                            format="YYYY-MM-DD"
                            size="small"
                            showTime={false}
                            presets={this.rangePresets.items}
                            onChange={this.onRangeChange}
                            style={{ width: "100%" }}
                            defaultValue={[dayjs().startOf("day"), dayjs()]}
                          />

                          <div className="fuel-data">
                            <div className="refuels-div">
                              <span className="refuels-title">
                                {" "}
                                {this.context.translate("_REFUELS_")} :&nbsp;
                                {this.state.fuelRefillData
                                  ? this.state.fuelRefillData.filter(
                                    (val) => val.refillfuel
                                  ).length
                                  : 0}
                              </span>
                            </div>

                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                top: "10px",
                              }}
                            >
                              <Select
                                placeholder="Interval"
                                onChange={async (e) => {
                                  await this.setState({ interval: e });
                                }}
                                options={[
                                  { value: "15", label: "15 Mins" },
                                  { value: "30", label: "30 Mins" },
                                  { value: "45", label: "45 Mins" },
                                  { value: "60", label: "60 Mins" },
                                  { value: "75", label: "75 Mins" },
                                  { value: "90", label: "90 Mins" },
                                  { value: "105", label: "105 Mins" },
                                  { value: "120", label: "120 Mins" },
                                ]}
                              />

                              <div
                                className={`pdf-download-button ${!hasData ? "disabled" : ""
                                  }`}
                                // className="pdf-download-button"
                                onClick={async () => {
                                  const data =
                                    await this.fuelGraphStore.downloadFuelGraph(
                                      {
                                        companyId: this.props.info.companyId,
                                        vehicleId: this.props.info.vehicleId,
                                        fromDate: this.state.fromDate,
                                        toDate: this.state.toDate,
                                        interval: this.state.interval,
                                      }
                                    );
                                }}
                              >
                                {this.context.translate("_DOWNLOAD_PDF_")}
                              </div>
                            </div>
                            {this.state.fuelRefillData?.map((val, index) =>
                              val.refillfuel ? (
                                <div
                                  key={index}
                                  style={{
                                    backgroundColor:
                                      this.state.selectedIndex === index
                                        ? "#d0d3d4"
                                        : "white",
                                  }}
                                  className="fuel-content-style"
                                  onClick={async () => {
                                    this.setState({
                                      selectedIndex: index,
                                      selectedData: val,
                                    });

                                    // this.props.This.mapRef.current.setView(
                                    //   [val.latitude, val.longitude],
                                    //   16
                                    // );
                                  }}
                                >
                                  <p>
                                    <span>
                                      {" "}
                                      {this.context.translate("_LOCATION_")}:
                                    </span>{" "}
                                    <small>
                                      {" "}
                                      {val.location ? val.location : "-"}
                                    </small>
                                  </p>

                                  <p>
                                    <span>
                                      {this.context.translate("_DATE_TIME_")} :
                                    </span>{" "}
                                    <small>
                                      {" "}
                                      {val.timestamp ? val.timestamp : "-"}
                                    </small>
                                  </p>
                                  <p>
                                    <span>
                                      {" "}
                                      {this.context.translate("_REFILL_FUEL_")}:
                                    </span>{" "}
                                    <small>
                                      {val.refillfuel
                                        ? parseFloat(
                                          val?.refillfuel?.toFixed(2)
                                        )
                                        : "-"}{" "}
                                      L
                                    </small>
                                  </p>
                                  <p>
                                    <span>
                                      {this.context.translate("_BEFORE_LEVEL_")}
                                      :
                                    </span>
                                    <small>
                                      {val.beforLevel ? val.beforLevel : "-"} L
                                    </small>
                                  </p>
                                  <p>
                                    <span>
                                      {this.context.translate(
                                        "_REFILL_FUEL_LEVEL_"
                                      )}
                                      :
                                    </span>
                                    <small>
                                      {val.refillfuellevel
                                        ? val.refillfuellevel
                                        : "-"}{" "}
                                      L
                                    </small>
                                  </p>
                                </div>
                              ) : null
                            )}
                          </div>
                        </div>
                      </>
                    ),
                  },
                  {
                    label: (
                      <Avatar
                        className="tabsImageStyle"
                        src={this.state.activeTab === "6" ? ssdIcon : ssdIcon}
                        onClick={async () => await this.handleObdData()}
                      />
                    ),
                    key: "6",
                    children: (
                      <>
                        <div className="obd-tab">
                          <div className="driver-performance">
                            <span className="title">
                              {this.context.translate("_OBD_VALUES_")}
                            </span>

                            <div className="driver-performance-list">
                              {this.props.info.movement_sensor !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Movement Sensor")}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.movement_sensor}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.lvcan_vehiclespeed !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Lvcan Vehiclespeed"
                                    )}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.lvcan_vehiclespeed}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.lvcan_pedalposition !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Lvcan Pedalposition"
                                    )}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.lvcan_pedalposition}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.engine_temp !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Engine Temp")}
                                  </span>
                                  <small>{this.state.showObdData?.engine_temp}</small>
                                </li>
                              )}

                              {this.state.showObdData?.fuel_pecnt !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Fuel Pecnt")}
                                  </span>
                                  <small>{this.state.showObdData?.fuel_pecnt}</small>
                                </li>
                              )}

                              {this.state.showObdData?.RPM !== null && (
                                <li className="listItems">
                                  <span>{this.context.translate("RPM")}</span>
                                  <small>{this.state.showObdData?.RPM}</small>
                                </li>
                              )}

                              {this.state.showObdData?.fuel !== null && (
                                <li className="listItems">
                                  <span>{this.context.translate("Fuel")}</span>
                                  <small>{this.state.showObdData?.fuel}</small>
                                </li>
                              )}

                              {this.state.showObdData?.fuel_consumed !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Fuel Consumed")}
                                  </span>
                                  <small>{this.state.showObdData?.fuel_consumed}</small>
                                </li>
                              )}

                              {this.state.showObdData?.fuel_consumed_counted !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Fuel Consumed Counted"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.fuel_consumed_counted}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.vehicle_mileage !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Vehicle Mileage")}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.vehicle_mileage}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.total_mileage_counted !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Total Mileage Counted"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.total_mileage_counted}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.lvcan_programe_number !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Ivcan Program Number"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.lvcan_programe_number}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.engine_worktime !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Engine Worktime")}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.engine_worktime}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.odometer !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Odometer")}
                                  </span>
                                  <small>{this.state.showObdData?.odometer}</small>
                                </li>
                              )}

                              {this.state.showObdData?.isCanbus !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Is Canbus")}
                                  </span>
                                  <small>{this.state.showObdData?.isCanbus}</small>
                                </li>
                              )}

                              {this.state.showObdData?.brake_switch !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Brake Switch")}
                                  </span>
                                  <small>{this.state.showObdData?.brake_switch}</small>
                                </li>
                              )}

                              {this.state.showObdData?.wheel_based_speed !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Wheel Based Speed"
                                    )}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.wheel_based_speed}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.cruise_control_active !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Cruise Control Active"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.cruise_control_active}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.clutch_switch !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Clutch Switch")}
                                  </span>
                                  <small>{this.state.showObdData?.clutch_switch}</small>
                                </li>
                              )}

                              {this.state.showObdData?.pto_state !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("PTO State")}
                                  </span>
                                  <small>{this.state.showObdData?.pto_state}</small>
                                </li>
                              )}

                              {this.state.showObdData?.acceleration_pedal_position !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Acceleration Pedal Position"
                                      )}
                                    </span>
                                    <small>
                                      {
                                        this.state.showObdData?.acceleration_pedal_position
                                      }
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.engine_current_load !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Engine Current Load"
                                    )}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.engine_current_load}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.engine_total_fuel_used !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Engine Total Fuel Used"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.engine_total_fuel_used}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.fuel_level !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Fuel Level")}
                                  </span>
                                  <small>{this.state.showObdData?.fuel_level}</small>
                                </li>
                              )}

                              {this.state.showObdData?.engine_speed !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Engine Speed")}
                                  </span>
                                  <small>{this.state.showObdData?.engine_speed}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight1 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight1")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight1}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight2 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight2")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight2}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight3 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight3")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight3}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight4 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight4")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight4}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight5 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight5")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight5}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight6 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight6")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight6}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight7 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight7")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight7}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight8 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight8")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight8}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight9 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight9")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight9}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight10 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight10")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight10}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight11 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight11")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight11}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight12 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight12")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight12}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight13 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight13")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight13}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight14 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight14")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight14}</small>
                                </li>
                              )}

                              {this.state.showObdData?.axle_weight15 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Axle Weight15")}
                                  </span>
                                  <small>{this.state.showObdData?.axle_weight15}</small>
                                </li>
                              )}

                              {this.state.showObdData?.engine_total_hours_of_operation !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Engine Total Hours Of Operation"
                                    )}
                                  </span>
                                  <small>
                                    {
                                      this.state.showObdData?.engine_total_hours_of_operation
                                    }
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.software_version_supported !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Software Version Supported"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.software_version_supported}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData.diagnostics_supported !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Diagnostics Supported"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.diagnostics_supported}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.requests_supported !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Requests Supported"
                                    )}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.requests_supported}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.service_distance !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Service Distance")}
                                  </span>
                                  <small>
                                    {this.state.showObdData?.service_distance}
                                  </small>
                                </li>
                              )}

                              {this.state.showObdData?.direction_indication !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Direction Indication"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.direction_indication}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.tachograph_performance !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Tachograph Performance"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.tachograph_performance}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.handling_info !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Handling Info")}
                                  </span>
                                  <small>{this.state.showObdData?.handling_info}</small>
                                </li>
                              )}

                              {this.state.showObdData?.system_event !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("System Event")}
                                  </span>
                                  <small>{this.state.showObdData?.system_event}</small>
                                </li>
                              )}

                              {this.state.showObdData?.engine_coolant_temperature !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Engine Coolant Temperature"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.engine_coolant_temperature}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.ambient_air_temperature !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Ambient Air Temperature"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.ambient_air_temperature}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.fuel_rate2 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Fuel Rate2")}
                                  </span>
                                  <small>{this.state.showObdData?.fuel_rate2}</small>
                                </li>
                              )}

                              {this.state.showObdData?.instantaneous_fuel_economy !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Instantaneous Fuel Economy"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.instantaneous_fuel_economy}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.pto_drive_engagement !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "PTO Drive Engagement"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.pto_drive_engagement}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.high_resolution_engine_total_fuel_used !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "High Resolution Engine Total Fuel Used"
                                      )}
                                    </span>
                                    <small>
                                      {
                                        this.state.showObdData?.high_resolution_engine_total_fuel_used
                                      }
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.adBlue_status !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("AdBlue Status")}
                                  </span>
                                  <small>{this.state.showObdData?.adBlue_status}</small>
                                </li>
                              )}

                              {this.state.showObdData?.brake_pedal_position !==
                                null && (
                                  <li className="listItems">
                                    <span>
                                      {this.context.translate(
                                        "Brake Pedal Position"
                                      )}
                                    </span>
                                    <small>
                                      {this.state.showObdData?.brake_pedal_position}
                                    </small>
                                  </li>
                                )}

                              {this.state.showObdData?.fuel_level2 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Fuel Level2")}
                                  </span>
                                  <small>{this.state.showObdData?.fuel_level2}</small>
                                </li>
                              )}

                              {this.state.showObdData?.mil_indicator !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("MIL Indicator")}
                                  </span>
                                  <small>{this.state.showObdData?.mil_indicator}</small>
                                </li>
                              )}

                              {this.state.showObdData?.tell_tale0 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Tell Tale0")}
                                  </span>
                                  <small>{this.state.showObdData?.tell_tale0}</small>
                                </li>
                              )}

                              {this.state.showObdData?.tell_tale1 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Tell Tale1")}
                                  </span>
                                  <small>{this.state.showObdData?.tell_tale1}</small>
                                </li>
                              )}

                              {this.state.showObdData?.tell_tale2 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Tell Tale2")}
                                  </span>
                                  <small>{this.state.showObdData?.tell_tale2}</small>
                                </li>
                              )}

                              {this.state.showObdData?.tell_tale3 !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("Tell Tale3")}
                                  </span>
                                  <small>{this.state.showObdData?.tell_tale3}</small>
                                </li>
                              )}

                              {this.state.showObdData?.adBlue_level !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate("AdBlue Level")}
                                  </span>
                                  <small>{this.state.showObdData?.adBlue_level}</small>
                                </li>
                              )}

                              {this.state.showObdData?.gross_combination_vehicle_weight !== null && (
                                <li className="listItems">
                                  <span>
                                    {this.context.translate(
                                      "Gross Combination Vehicle Weight"
                                    )}
                                  </span>
                                  <small>
                                    {
                                      this.state.showObdData
                                        ?.gross_combination_vehicle_weight
                                    }
                                  </small>
                                </li>
                              )}
                            </div>
                          </div>
                        </div>
                      </>
                    ),
                  },
                ]}
              ></Tabs>
            </div>
          </div>
        </Card>

        {this.state.shareModalVisible && (
          <ShareModalWindow
            shareModalCloseFunc={(resp) => {
              this.setState({ shareModalVisible: resp });
            }}
            shareSingleLocation={this.state.shareModalVisible}
          />
        )}
      </>
    );
  }
}
VehicleOtherInfo.contextType = StoreContext;
export default observer(withRouter(VehicleOtherInfo));
